import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function HoursLocation() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-cream relative" data-id="element-291" data-mp="32q4qbpbfhqm4">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-292" data-mp="2xrbcfvs8bxlf">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16" data-id="element-293" data-mp="2xop6u1owfs5u">
          {/* Location Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-294" data-mp="3qf7hbnrycvta">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-6 md:mb-8" data-id="element-295" data-mp="2a1z8pbfo8hqi">
              {t('hours.title')}
            </h2>

            <div className="space-y-8" data-id="element-296" data-mp="2547g0f77crl9">
              <div className="flex items-start gap-4" data-id="element-297" data-mp="2n62c5l6fanz1">
                <div className="bg-white p-3 rounded-full shadow-sm text-brand-gold" data-id="element-298" data-mp="2n4hf9owmysy0">
                  <MapPin className="w-6 h-6" data-id="element-299" data-mp="2r749fwgs4pyd" />
                </div>
                <div data-id="element-300" data-mp="2d732q0du2oaz">
                  <h3 className="font-bold text-brand-charcoal text-lg mb-1" data-id="element-301" data-mp="2d7wa93km9hu6">
                    {t('hours.location')}
                  </h3>
                  <p className="text-gray-600" data-id="element-302" data-mp="23il2plddol8e">Phenix Salon Suite (#114)</p>
                  <p className="text-gray-600" data-id="element-303" data-mp="23gi267eln9pf">100 Broadway</p>
                  <p className="text-gray-600" data-id="element-304" data-mp="289uogavt34f0">Elmwood Park, NJ 07407</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-305" data-mp="1ujhkejm1c9uy">
                <div className="bg-white p-3 rounded-full shadow-sm text-brand-gold" data-id="element-306" data-mp="1zfy7dahi0i6g">
                  <Phone className="w-6 h-6" data-id="element-307" data-mp="1kjql84mj56oj" />
                </div>
                <div data-id="element-308" data-mp="1kljuzssfw70r">
                  <h3 className="font-bold text-brand-charcoal text-lg mb-1" data-id="element-309" data-mp="1piac8jfzd8nr">
                    {t('hours.contact')}
                  </h3>
                  <a href="tel:5513328938" className="text-brand-gold hover:text-brand-gold-light font-medium text-xl transition-colors" data-id="element-310" data-mp="16eqbqhnor43c">
                    (551) 332-8938
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Hours Table */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 md:p-10 rounded-sm shadow-lg border border-brand-gold/10" data-id="element-311" data-mp="1pcj8113t0frr">
            <div className="flex items-center gap-3 mb-8" data-id="element-312" data-mp="3xdbvic3akq8">
              <Clock className="w-6 h-6 text-brand-gold" data-id="element-313" data-mp="3v4pu80opl47q" />
              <h3 className="text-2xl font-serif text-brand-brown" data-id="element-314" data-mp="2anqichvvb41w">
                {t('hours.hours_title')}
              </h3>
            </div>

            <div className="space-y-4" data-id="element-315" data-mp="2fnl82i3wpnld">
              <div className="flex justify-between items-center py-3 border-b border-gray-100" data-id="element-316" data-mp="2fkgvawcdljj3">
                <span className="font-medium text-brand-charcoal" data-id="element-317" data-mp="2kk38j5s7ezrw">
                  {t('hours.mon_fri')}
                </span>
                <span className="text-gray-600" data-id="element-318" data-mp="2uc8zqdamtd61">9:00 AM – 7:00 PM</span>
              </div>
              <div className="flex justify-between items-center py-3 border-b border-gray-100" data-id="element-319" data-mp="2yd18z6ji7i2b">
                <span className="font-medium text-brand-charcoal" data-id="element-320" data-mp="33cnm7fzc0yb4">
                  {t('hours.sat')}
                </span>
                <span className="text-gray-600" data-id="element-321" data-mp="38bqud9alzknb">9:00 AM – 8:00 PM</span>
              </div>
              <div className="flex justify-between items-center py-3" data-id="element-322" data-mp="18ywjz1jc1gpp">
                <span className="font-medium text-brand-charcoal" data-id="element-323" data-mp="1dxg4qym6wmgh">
                  {t('hours.sun')}
                </span>
                <span className="text-gray-600" data-id="element-324" data-mp="34e1t1xw0xmo5">10:00 AM – 4:30 PM</span>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-brand-gold/20 text-center" data-id="element-325" data-mp="2zg9voocm18ck">
              <p className="text-sm text-brand-brown font-medium" data-id="element-326" data-mp="3dfrn7bhaizpm">
                {t('hours.footer')}
              </p>
            </div>
          </motion.div>
        </div>

        {/* Interactive Google Map */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-10 md:mt-16 rounded-sm overflow-hidden shadow-lg border border-brand-gold/10" data-id="element-327" data-mp="2lnahcpokdk6l">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3014.84615485456!2d-74.1232019!3d40.919118999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2fddb78ca8225%3A0xe90d5f6a3e2244e5!2z8J2Vi_CdlLjwnZWA4oSd8J2VjCDwnZS44J2UvPCdlYrwnZWL4oSN8J2UvPCdlYvwnZWA4oSC8J2Vig!5e0!3m2!1ses-419!2sus!4v1777744988187!5m2!1ses-419!2sus" width="100%" height="350" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación de Tairu Aesthetics - Phenix Salon Suite, Elmwood Park NJ" className="w-full" data-id="element-328" data-mp="21y9st2llncfr"></iframe>
        </motion.div>
      </div>
    </section>;
}